import * as React from "react";
import { Topic } from "../types";
import useApi from "@/hooks/useApi";

export default function useTopics() {
  const [topics, setTopics] = React.useState<Topic[]>([]);
  const [loadingTopics, setLoadingTopics] = React.useState(true);
  const api = useApi();

  const fetchTopics = React.useCallback(async () => {
    setLoadingTopics(true);
    try {
      const response = await api.admin.get("api/kb/topics");
      const json = await response.json();
      setTopics(Array.isArray(json?.topics ?? json?.Topics) ? (json?.topics ?? json?.Topics) : []);
    } catch (err) {
      console.error("Failed to fetch KB topics:", err);
      setTopics([]);
    } finally {
      setLoadingTopics(false);
    }
  }, []);

  React.useEffect(() => {
    fetchTopics();
  }, [fetchTopics]);

  const updateTopics = React.useCallback(async (topics: Topic[]) => {
    await api.admin.post("api/kb/topics/update-many", { topics });
  }, []);

  function addTopic(topic: Topic) {
    setTopics((oldState) => [...oldState, topic]);
  }

  return {
    topics,
    setTopics,
    loadingTopics,
    addTopic,
    fetchTopics,
    updateTopics
  };
}
